/**
 *
 * inject script to facilitate iframe resizing
 * https://github.com/davidjbradshaw/iframe-resizer
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
//require("../../../scripts/iframeResizer");
import { factory } from "../../../scripts/iframeResizer";
import * as Tools from "../../helpers/Tools";
import Spinner from "./spinner";

class IframeResizer extends React.Component {
    constructor(props) {
        super(props);
        this.iFrameResizerLib = factory();
        this.injectIntoDocument = this.injectIntoDocument.bind(this);
        this.state = {
            showSpinner: true
        };
    }
    componentDidMount() {
        //debugger;
        // can't update until we have a mounted iframe
        this.updateIframe(this.props);
        this.resizeIframe(this.props);
        if (!this.state.showSpinner) {
            this.setState({ showSpinner: true });
        }
    }
    componentWillReceiveProps(nextProps) {
        // can replace content if we got new props
        if (nextProps.id !== this.props.id || nextProps.src !== this.props.src) {
            //debugger;
            if (!this.state.showSpinner) {
                this.setState({ showSpinner: true });
            }
            this.updateIframe(nextProps);
            this.resizeIframe(nextProps);
            //debugger;
        }
    }
    componentWillUnmount() {
        // React will remove the iframe, however we need to manually
        // call iframe-resizer to stop its listeners
        const iframeResizer = this.refs.frame.iFrameResizer;
        iframeResizer && iframeResizer.removeListeners();
        //this.iFrameResizerLib = factory();
    }
    updateIframe = (props) => {
        // has src - no injected content
        if (props.src) return;
        // do we have content to inject (content or children)
        const content = props.content || props.children;
        if (!content) return;
        // get frame to inject into
        const frame = this.refs.frame;
        if (!frame) return;
        // verify frame document access
        // Due to browser security, this will fail with the following error
        //   Uncaught DOMException: Failed to read the 'contentDocument' property from 'HTMLIFrameElement':
        //   Blocked a frame with origin "http://<hostname>" from accessing a cross-origin frame.
        // resolve this by loading documents from the same domain name,
        // or injecting HTML `content` vs. loading via `src`
        const doc = frame.contentDocument;
        if (!doc) return;
        // replace iframe document content
        if (typeof content === 'string') {
            // assume this is a HTML block
            //   we could send this in via REACT dangerously set HTML
            //   but we are in an iframe anyway, already a red-headed step-child.
            doc.open();
            doc.write(content);
            doc.close();
        } else {
            // assume this is a REACT component
            doc.open();
            doc.write('<div id="iframe-root"></div>');
            doc.close();
            ReactDOM.render(content, doc.getElementById('iframe-root'))
        }
    }
    injectScriptBlock = (sBlockID, sScript, sScriptURL, sType) => {
        const frame = this.refs.frame;
        if (!frame) {
            //debugger;
            return;
        }
        
        let doc = "";
        try { doc = frame.contentDocument; } catch (e) { }
        if (!doc) {
            //debugger;
            return;
        }

        let SecondFrame = frame.contentDocument.getElementById("frmMyChart");
        if (SecondFrame)
        {
            //debugger;
            let SecondDoc = null;
            try { SecondDoc = SecondFrame.contentDocument } catch (e) {}
            if (SecondDoc) {
                this.injectIntoDocument(SecondDoc, sBlockID, sScript, sScriptURL, sType);
                //doc = SecondDoc;
            }
        }

        this.injectIntoDocument(doc, sBlockID, sScript, sScriptURL, sType);

        //debugger;
        //let injectTarget = null;
        //['head', 'HEAD', 'body', 'BODY', 'div', 'DIV'].forEach(tagName => {
        //    if (injectTarget) return;
        //    const found = doc.getElementsByTagName(tagName);
        //    if (!(found && found.length)) return;
        //    injectTarget = found[0];
        //});
        //if (!injectTarget) {
        //    console.error('Unable to inject iframe resizer script');
        //    return;
        //}
        //if (!(sType === 'css')) {
        //    const resizerScriptElement = document.createElement('script');
        //    resizerScriptElement.type = 'text/javascript';
        //    if (sScriptURL) {
        //        resizerScriptElement.src = sScriptURL;
        //    }
        //    else if (sScript) {
        //        resizerScriptElement.text = sScript;
        //    }
        //    if (sBlockID) {
        //        resizerScriptElement.id = sBlockID;
        //        if (injectTarget.ownerDocument.getElementById(sBlockID)) {
        //            return; // already injected
        //        }
        //    }

        //    injectTarget.appendChild(resizerScriptElement);
        //}
        //else if(sType === 'css') {
        //    const resizerCSSElement = document.createElement("link");
        //    resizerCSSElement.type = "text/css";
        //    resizerCSSElement.rel = "stylesheet";

        //    if (sScriptURL) {
        //        resizerCSSElement.href = sScriptURL;
        //    }

        //    injectTarget.appendChild(resizerCSSElement);
        //}

    }
    injectIntoDocument(doc, sBlockID, sScript, sScriptURL, sType) {
        let injectTarget = null;
        ['head', 'HEAD', 'body', 'BODY', 'div', 'DIV'].forEach(tagName => {
            if (injectTarget) return;
            const found = doc.getElementsByTagName(tagName);
            if (!(found && found.length)) return;
            injectTarget = found[0];
        });
        if (!injectTarget) {
            console.error('Unable to inject iframe resizer script');
            return;
        }
        if (!(sType === 'css')) {
            const resizerScriptElement = document.createElement('script');
            resizerScriptElement.type = 'text/javascript';
            if (sScriptURL) {
                resizerScriptElement.src = sScriptURL;
            }
            else if (sScript) {
                resizerScriptElement.text = sScript;
            }
            if (sBlockID) {
                resizerScriptElement.id = sBlockID;
                if (injectTarget.ownerDocument.getElementById(sBlockID)) {
                    return; // already injected
                }
            }

            injectTarget.appendChild(resizerScriptElement);
        }
        else if (sType === 'css') {
            const resizerCSSElement = document.createElement("link");
            resizerCSSElement.type = "text/css";
            resizerCSSElement.rel = "stylesheet";

            if (sScriptURL) {
                resizerCSSElement.href = sScriptURL;
            }

            injectTarget.appendChild(resizerCSSElement);
        }
    }


    // inject the iframe resizer "content window" script
    injectIframeResizerUrl = () => {
        if (!this.props.iframeResizerUrl) {
            //debugger;
            return;
        }
        //debugger;
        this.injectScriptBlock("iFrameResizer", null, this.props.iframeResizerUrl);
    }
    onLoad = () => {

        try { window.parent.scrollTo(0, 0); } catch (e) { }
        try { window.parent.document.body.scrollTop = 0; } catch (e) { }
        try { window.parent.document.documentElement.scrollTop = 0; } catch (e) { }

        this.injectIframeResizerUrl();
        if (this.props.additionalScripts) {
            this.props.additionalScripts.forEach(sURL => {
                this.injectScriptBlock(null, null, sURL);
            });
        }
        if (this.props.additionalCSS) {
            this.props.additionalCSS.forEach(sURL => {
                this.injectScriptBlock(null, null, sURL, 'css');
            });
        }

        window.formChanged = false; // reset this every postback (assuming a successful submit of some kind)
        // DISABLED because it's causing a loading loop :(
        if (this.props.onIframeLoaded) this.props.onIframeLoaded(this.refs.frame); //initCallback not getting called in case of error , so adding this back just to hide spinner 

        if (this.state.showSpinner) {
            this.setState({ showSpinner: false });
        }

        // --> We can't do this at all.  PDFs in Firefox and ALL mobile browsers shows up null, there is no other distinguishing information on the frame to decide on
        //const iframe = this.refs.frame;
        //const doc = iframe.contentDocument;
        //if (doc === null && navigator.userAgent.toLowerCase().indexOf('firefox') === -1) {  // doc returns null in case of 404/error  ... in the case of Firefox, PDFs from GetFile also show up as null so we can't do this for firefox
        //    if (this.props.onError) this.props.onError();
        //}

    }
    onReadyStateChange = () => {
        //debugger;
        if (this.ref.frame.readyState === 0) {
            //debugger;
        }
    }

    resizeIframe = (props) => {
        const frame = this.refs.frame;
        if (!frame) {
            //debugger;
            return;
        };
        if (props.iframeResizerEnable) {
            this.iFrameResizerLib(props.iframeResizerOptions, frame);
        }
    }
    render() {
        const { src, id, frameBorder, className, style, title } = this.props;
        const { showSpinner } = this.state;
        return (
            <React.Fragment>
                <iframe
                    ref="frame"
                    src={src}
                    frameBorder={frameBorder}
                    className={className}
                    style={style}
                    onLoad={this.onLoad}
                    title={title ? title : ""}
                />
                {this.state.showSpinner &&
                    <Spinner />
                }
            </React.Fragment>
        );
    }
}
IframeResizer.propTypes = {
    // iframe content/document
    // option 1. content of HTML to load in the iframe
    content: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]),
    // option 2. src to a URL to load in the iframe
    src: PropTypes.string,
    // iframe-resizer controls and helpers
    iframeResizerEnable: PropTypes.bool,
    iframeResizerOptions: PropTypes.object,
    iframeResizerUrl: PropTypes.oneOfType([
        PropTypes.string, // URL to inject
        PropTypes.bool, // false = disable inject
    ]),
    // misc props to pass through to iframe
    id: PropTypes.string,
    frameBorder: PropTypes.number,
    className: PropTypes.string,
    style: PropTypes.object,
    // optional extra callback when iframe is loaded
    // onIframeLoaded: PropTypes.func,
};
IframeResizer.defaultProps = {
    // resize iframe
    iframeResizerEnable: true,
    iframeResizerOptions: {
        // log: true,
        // autoResize: true,
        // checkOrigin: false,
        // resizeFrom: 'parent',
        // heightCalculationMethod: 'max',
        // initCallback: () => { console.log('ready!'); },
        // resizedCallback: () => { console.log('resized!'); },
        warningTimeout: 10000
    },
    iframeResizerUrl: window.location.origin + '/scripts/iframeResizer.contentWindow.js',
    // misc props to pass through to iframe
    frameBorder: 0,
    style: {
        width: '100%',
        minHeight: 20,
    },
};

export default IframeResizer;
